var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "autocomplete",
      class:
        ((_obj = {}),
        (_obj[_vm.height] = _vm.height),
        (_obj.loading = _vm.isLoading),
        (_obj.ready = !_vm.isLoading),
        _obj)
    },
    [
      _c("v-select", {
        ref: "autocomplete",
        attrs: {
          "clear-search-on-blur": function() {
            return false
          },
          filterable: false,
          loading: _vm.isLoading,
          multiple: _vm.multiple,
          options: _vm.options,
          placeholder: _vm.placeholder,
          searchable: true
        },
        on: { input: _vm.onSelectChange, search: _vm.onSelectSearch },
        scopedSlots: _vm._u([
          {
            key: "no-options",
            fn: function(ref) {
              var search = ref.search
              var searching = ref.searching
              return [
                searching
                  ? [
                      _vm._v("\n        No results found for "),
                      _c("em", [_vm._v('"' + _vm._s(search) + '"')]),
                      _vm._v(".\n      ")
                    ]
                  : _c("em", { staticClass: "empty-hint" }, [
                      _vm._v(_vm._s(_vm.emptyHint))
                    ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61348a8b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61348a8b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/autocomplete.vue
// module id = 1248
// module chunks = 0